import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { getOneCmsApiUrl } from '../selectors/selectors';
import { MODULENAME, ROOT_LOAD_LOCALES_MARKETENABLEMENTS } from '../constants/constants';

export const getAllowedLocales = (state, fetchClient = fetch) => {
  const url = `${getOneCmsApiUrl(state)}/Internet/travel/hub/common/marketEnablements.json`;
  return fetchClient(url, { credentials: 'omit' })
    .then((res) => res?.json())
    .then((response) => response)
    .catch((error) => {
      const errorData = { message: 'An Error occurred while fetching locales', moduleName: MODULENAME, customerJourney: ROOT_LOAD_LOCALES_MARKETENABLEMENTS };
      addErrorToReport(error, errorData);
      throw new Error('An Error occurred while fetching locales', error);
    });
};
